export enum LocalAccessRoles {
  AUTHORIZED = 'AUTHORIZED',
  ANONYMOUS = 'ANONYMOUS',
}
